import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader, Card, Chip } from "@/components/kit";
import { formatISTDateTime } from "@/lib/date";

export default function AuditLog() {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    api.get("/reports/audit").then(r => setRows(r.data));
  }, []);
  return (
    <div data-testid="audit-page">
      <PageHeader title="Audit Trail" subtitle="Immutable record of every important action." />
      <div className="p-6">
        <Card>
          <table className="w-full data-table" data-testid="audit-table">
            <thead><tr>
              <th className="px-3 py-2 text-left">Time</th>
              <th className="px-3 py-2 text-left">User</th>
              <th className="px-3 py-2 text-left">Module</th>
              <th className="px-3 py-2 text-left">Action</th>
              <th className="px-3 py-2 text-left">Record</th>
              <th className="px-3 py-2 text-left">Reason</th>
            </tr></thead>
            <tbody>
              {rows.length === 0 && <tr><td colSpan={6} className="text-center py-8 text-zinc-500 text-sm">No audit records yet.</td></tr>}
              {rows.map((r) => (
                <tr key={`${r.record_id || "x"}-${r.created_at}-${r.action}`}>
                  <td className="px-3 py-2 font-mono text-[11px]">{formatISTDateTime(r.created_at)}</td>
                  <td className="px-3 py-2">{r.user_email} <span className="text-[10px] text-zinc-500">({r.user_role})</span></td>
                  <td className="px-3 py-2"><Chip tone="info">{r.module}</Chip></td>
                  <td className="px-3 py-2 font-mono">{r.action}</td>
                  <td className="px-3 py-2 font-mono text-[11px]">{r.record_id}</td>
                  <td className="px-3 py-2 text-[11px]">{r.reason || "-"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </Card>
      </div>
    </div>
  );
}
